import { BrString } from "Components/BrString";
import { Images } from "Components/Images";
import React from "react";
import { Card } from "react-bootstrap";

export default function GenericCardRenderer(props: {model: {
	getDisplayName: () => string,
	getIcon: () => string,
	getBadge?: () => string,
}}) {
	const {model} = props;
	const badge = props.model?.getBadge?.();
	return (
		<Card style={{height:"auto", minWidth: 100, maxWidth: "30vw"}}>
			<Card.Img variant="top" src={model.getIcon()} />
			<Card.ImgOverlay style={{margin: 0, padding:0}}>
				<Card.Body style={{margin: 0, padding:0}}>
					<Card.Footer 
					className="text-center bg-violet-transparent-70 d-none d-lg-block text-white"
					style={{width: "100%"
						, bottom:0, position: "absolute", paddingLeft: 0, paddingRight: 0
					}}
					>
						{!!badge && <Images.Icon style={{opacity: "unset"}} imgUrl={badge} size="2.2rem"/>}
						<BrString>{model.getDisplayName()}</BrString>
					</Card.Footer>
				</Card.Body>
			</Card.ImgOverlay>
			<Card.Footer
			style={{padding:2}}
			className="text-center d-block d-lg-none"
			>
				<BrString>{model.getDisplayName()}</BrString>
			</Card.Footer>
		</Card>
	);
}